
import { gsap } from "gsap"
export default
    name: 'event-stats'
    data: ->
        distance: general.extra.stats.total_distance || 0
        tweenedDistance: general.extra.stats.total_distance || 0
        refresh_at: 5
    computed:
        theDistance: ->
            (@tweenedDistance / 1000).toFixed(0)
    filters:
        theFormat: (val) ->
            parseFloat(val).toLocaleString('ru-RU')
    mounted: ->
        setInterval ( =>
            @refresh()
        ), @refresh_at * 1000
    methods:
        refresh: ->
            @axios.get(window.location.href)
                .then (res) => @distance = res.data.total_distance
                .catch (e) -> console.log e
    watch:
        distance: (newValue) ->
          gsap.to(@$data, { duration: 5, tweenedDistance: newValue })

